module.exports = __webpack_public_path__ + "img/cargill.2ed88d6d.png";